import { render, staticRenderFns } from "./BatteryCost.vue?vue&type=template&id=31d8b927&"
import script from "./BatteryCost.vue?vue&type=script&lang=js&"
export * from "./BatteryCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports